import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const user = await login(email, password);
      if (user.role === 'admin') navigate('/admin');
      else navigate('/catalogue');
    } catch(err) {
      setError(err.response?.data?.error || 'Login failed. Please check your details.');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" className="auth-logo">ElevenNorth <span>&amp; Co.</span></Link>
          <p className="tag">Welcome Back</p>
          <h1 className="auth-title">Log in to Your<br/><em>Account</em></h1>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={submit} className="auth-form">
          <div className="form-group">
            <label>Email Address</label>
            <input required type="email" value={email} onChange={e=>setEmail(e.target.value)} placeholder="you@company.com" autoFocus />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input required type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Your password" />
          </div>
          <button type="submit" className="btn-primary" style={{width:'100%',justifyContent:'center',padding:'16px'}} disabled={loading}>
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
        <p className="auth-switch">Don't have an account? <Link to="/register">Register as a buyer</Link></p>
      </div>
    </div>
  );
}
